var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-schema-form', { ref: "form", staticClass: "tag-ids", attrs: { "schema": _vm.schema, "model": _vm.formModel, "layout": _vm.layout } });
};
var staticRenderFns = [];

export { render, staticRenderFns };